import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface PageProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Minimum width of the screen, padding included; `main` scrolls horizontally below it. Use the
   * real minimum of the content (at most 968, the narrowest `main`), not the design's 1000–1170.
   */
  readonly minWidth?: number;
}

/** Screen wrapper: `padding:20px 20px 32px` plus the screen's min-width. */
export function Page({ minWidth, className, style, ...rest }: PageProps) {
  return <div className={cn('px-5 pb-8 pt-5', className)} style={{ minWidth, ...style }} {...rest} />;
}
